import {
  CalendarCheck,
  HeartHandshake,
  Home,
  Plus,
} from "lucide-react";
import { Link } from "react-router-dom";

import { useEffectivePermissions } from "@/features/authorization/hooks/useEffectivePermissions";
import { Card } from "@/components/ui/card";

export function OverviewQuickActions() {
  const { permissions } = useEffectivePermissions();
  return (
    <Card className="self-start overflow-hidden">
      <div className="border-b border-slate-800 px-6 py-5">
        <h2 className="text-xl font-semibold text-white">
          Quick Actions
        </h2>

        <p className="mt-1 text-sm text-slate-500">
          Common ministry tasks
        </p>
      </div>

      <div className="grid gap-3 p-5 sm:grid-cols-2 xl:grid-cols-1 2xl:grid-cols-2">
        {permissions.has("MEMBERS_VIEW") && permissions.has("MEMBERS_MANAGE") && <QuickAction
          to="/members"
          icon={<Plus size={19} />}
          label="Add Member"
          className="text-emerald-400"
        />}

        {permissions.has("ATTENDANCE_VIEW") && permissions.has("ATTENDANCE_MANAGE") && <QuickAction
          to="/attendance"
          icon={<CalendarCheck size={19} />}
          label="Take Attendance"
          className="text-sky-400"
        />}

        {permissions.has("HOUSEHOLDS_VIEW") && permissions.has("HOUSEHOLDS_MANAGE") && <QuickAction
          to="/households"
          icon={<Home size={19} />}
          label="Manage Households"
          className="text-violet-400"
        />}

        {permissions.has("CARE_VIEW") && <QuickAction
          to="/care-queue"
          icon={<HeartHandshake size={19} />}
          label="View Follow-ups"
          className="text-rose-400"
        />}
      </div>
    </Card>
  );
}

function QuickAction({
  to,
  icon,
  label,
  className,
}: {
  to: string;
  icon: React.ReactNode;
  label: string;
  className: string;
}) {
  return (
    <Link
      to={to}
      className="group flex min-h-16 items-center gap-3 rounded-xl border border-slate-800 bg-slate-950/50 px-4 py-3 transition-all duration-200 hover:-translate-y-0.5 hover:border-slate-700 hover:bg-slate-800/70"
    >
      <span
        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-slate-800 transition duration-200 group-hover:scale-105 ${className}`}
      >
        {icon}
      </span>

      <span className="font-semibold text-white">
        {label}
      </span>
    </Link>
  );
}

